"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticSaleSourceID = exports.SaleSourceType = void 0;
var SaleSourceType;
(function (SaleSourceType) {
    SaleSourceType[SaleSourceType["Static"] = 0] = "Static";
    SaleSourceType[SaleSourceType["Dynamic"] = 1] = "Dynamic";
})(SaleSourceType = exports.SaleSourceType || (exports.SaleSourceType = {}));
var StaticSaleSourceID;
(function (StaticSaleSourceID) {
    StaticSaleSourceID["OrderApp"] = "41f6903b-398a-472d-8262-c239b0ac378d";
    StaticSaleSourceID["OrderWeb"] = "90011053-1b28-451d-80fb-2360c2f71cac";
    StaticSaleSourceID["POSClient"] = "125fbb38-16d3-4703-bf10-fde88fae4ddd";
    StaticSaleSourceID["ExpressClient"] = "e4b427b0-5e72-46d4-83e3-374589b952e2";
    StaticSaleSourceID["Deliverect"] = "0e9e3f50-8056-4fc1-989c-6c0f31ae3856";
    StaticSaleSourceID["CloudAdmin"] = "fe0a419b-8102-4137-9cf6-2094a3952560";
    StaticSaleSourceID["Maitres"] = "b08885df-14ce-488b-9f79-19e1849207a3";
    StaticSaleSourceID["PayAndGo"] = "6988a7d6-8765-4bd7-bd30-14b4a09c97a1";
})(StaticSaleSourceID = exports.StaticSaleSourceID || (exports.StaticSaleSourceID = {}));
